import * as Yup from 'yup'
import { Col, Form } from 'react-bootstrap'
import { CustomFormControl, CustomFormSelect } from '../../../../StyledComponents';
import { Options } from '../SelectOptions';
import { checkRequiredText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    applicationAs: checkRequiredText(settings),
});

export const ApplicationAsSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formApplicationAs">
                <Form.Label>Bewerbung als*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Bewerbung als"
                    name="applicationAs"
                    value={values.applicationAs}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.applicationAs && !errors.applicationAs}
                    isInvalid={touched.applicationAs && errors.applicationAs}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.applicationAs}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} controlId="formPreferredLocation1">
                <Form.Label>Präferierter Standort</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name="preferredLocation1"
                    value={values.preferredLocation1}
                    isValid={touched.preferredLocation1 && !errors.preferredLocation1}
                    isInvalid={errors.preferredLocation1}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.PreferredLocation.map((item, index) => <option key={index}>{item}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.preferredLocation1}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};